import { render, staticRenderFns } from "./AppOrgExpireAlert.vue?vue&type=template&id=0f55a9bf&scoped=true&"
import script from "./AppOrgExpireAlert.vue?vue&type=script&lang=js&"
export * from "./AppOrgExpireAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55a9bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCard,VImg})
